import { FrameRange } from 'content-creation-common/models';

import { createSelector } from 'reselect';
import { TIME_RANGE_ABSOLUTE_MAX_FRAME } from '../../creative/state-management/constants';
import { roundToDecimal } from '../../../../util/numbers';
import { PLAYBACK_FRAMES_PER_SECOND } from '../../../../constants';

export const getCurrentCreativeId = (state) => state.playback.creativeId;
export const getCreativeTemplateId = (state) =>
  state.playback.creativeTemplateId;
export const getRootStartFrame = (state) =>
  state.elements.masks.root.frameStart || 0;
export const getCreativeVersionId = (state) => state.playback.creativeVersionId;
export const getRootEndFrame = (state) =>
  state.elements.masks.root.frameEnd || TIME_RANGE_ABSOLUTE_MAX_FRAME;
export const isBuffering = (state) => state.playback.isBuffering;

export const getRootFrameRange = createSelector(
  [getRootStartFrame, getRootEndFrame],
  (start, end) => {
    return new FrameRange(start, end);
  },
);

export const getTotalFrames = (state) => {
  const startFrame = getRootStartFrame(state);
  const endFrame = getRootEndFrame(state);
  return endFrame - startFrame + 1;
};

export const getTotalTime = createSelector([getTotalFrames], (totalFrames) => {
  return roundToDecimal(totalFrames / PLAYBACK_FRAMES_PER_SECOND, 2);
});
